document.addEventListener("DOMContentLoaded", () => {
    const blocks = document.querySelectorAll(".two-columns-portal");
    blocks.forEach((block, index) => {
      const image = block.querySelector(".two-columns-portal__image-one");
  
      if (image) {
        ScrollTrigger.create({
          trigger: block,
          start: "-200px center",
          end: "bottom center",
          onEnter: () => {
            // Animate the image
            gsap.to(image, {
              x: 0,
              opacity: 1,
              duration: 2.3,
              ease: "power3.out",
            });
          },
        });
      }
    });
    const blocksMobApp = document.querySelectorAll(".two-columns-mobile-app ");
    blocksMobApp.forEach((block, index) => {
      const image = block.querySelector(".two-columns-mobile-app__image");
  
      if (image) {
        ScrollTrigger.create({
          trigger: block,
          start: "-200px center",
          end: "bottom center",
          onEnter: () => {
            // Animate the image
            gsap.to(image, {
              x: 0,
              opacity: 1,
              duration: 2.3,
              ease: "power3.out",
            });
          },
        });
      }
    });
    
    const assistant = document.querySelector(".ai-assistant")

    if (assistant) {
      ScrollTrigger.create({
        trigger: assistant,
        start: "top 80%",
        toggleClass: "active",
        once: true
      })
    }

      /* ai-images
    --------------------------------------------- */
  if (document.querySelector(".ai-images")) {
    ScrollTrigger.create({
      trigger: ".ai-images",
      start: "top bottom",
      end: "bottom top",
      onEnter: () => {
        
        gsap.fromTo(
          ".ai-images",
          { y: 0, opacity: 0 },
          { y: 0, opacity: 1, duration: 2.3, ease: "power3.out" }
        );
      },
      once: true,
    });
    ScrollTrigger.create({
      trigger: ".ai-images-item",
      onEnter: () => {
        gsap.fromTo(
          ".ai-images-item-1",
          { x: -500, opacity: 0 },
          { x: 0, opacity: 1, duration: 2, ease: "power3.out" }
        );

        gsap.fromTo(
          ".ai-images-item-3",
          { x: 500, opacity: 0 },
          { x: 0, opacity: 1, duration: 2, ease: "power3.out" }
        );

        setTimeout(() => {
          document.querySelector('.ai-images-item-1').classList.add('active')
          document.querySelector('.ai-images-item-2').classList.add('active')
        }, 1000);
      },
      once: true,
    });
  }
})